import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import formStyles from "@/styles/Form.module.scss";
import { Button } from "../Buttons";
import { useCallback, useEffect, useState, useRef, forwardRef } from "react";
import { useForm } from "react-hook-form";
import routes from "@/lib/routes";
import { SelectField, HiddenField } from "../Form/Parts";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ChatMessageReportStepReport = props => {
  const {
    0: reason,
    1: setReason
  } = useState("商業目的のコンテンツやスパム");
  const handleReportSend = useCallback(() => {
    props.handleReportSend(props.id, reason);
  }, [props, reason]);
  const onClickHandle = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  const onChangeHandle = useCallback(e => {
    setReason(e.value);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("header", {
      children: [/*#__PURE__*/_jsx("h3", {
        children: "\u901A\u5831\u7406\u7531"
      }), /*#__PURE__*/_jsx("p", {
        children: "\u901A\u5831\u7406\u7531\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
      })]
    }), /*#__PURE__*/_jsx("div", {
      onClick: onClickHandle,
      children: /*#__PURE__*/_jsx("fieldset", {
        className: `${formStyles.basicFieldset} ${formStyles.marginOff}`,
        children: /*#__PURE__*/_jsx(SelectField, {
          name: "reason",
          options: [{
            value: "差別的、わいせつ的、暴力的な発言内容",
            label: "差別的、わいせつ的、暴力的な発言内容",
            order: 1
          }, {
            value: "嫌がらせ、煽り、過度ないたずら",
            label: "嫌がらせ、煽り、過度ないたずら",
            order: 2
          }, {
            value: "脅迫、恐喝、詐欺など違法行為",
            label: "脅迫、恐喝、詐欺など違法行為",
            order: 3
          }, {
            value: "個人情報の漏洩や権利の侵害",
            label: "個人情報の漏洩や権利の侵害",
            order: 4
          }, {
            value: "スパム行為、荒らしなどの迷惑行為",
            label: "スパム行為、荒らしなどの迷惑行為",
            order: 5
          }, {
            value: "商用目的の利用",
            label: "商用目的の利用",
            order: 6
          }, {
            value: "その他不適切な内容",
            label: "その他不適切な内容",
            order: 7
          }],
          readOnly: true,
          required: true,
          placeholder: "\u901A\u5831\u7406\u7531\u3092\u9078\u629E",
          defaultValue: {
            value: "差別的、わいせつ的、暴力的な発言内容",
            label: "差別的、わいせつ的、暴力的な発言内容"
          },
          onChange: onChangeHandle,
          customStyles: {
            control: provided => _objectSpread(_objectSpread({}, provided), {}, {
              color: "#FFF",
              backgroundColor: "#101112",
              border: "#101112"
            }),
            menuList: provided => _objectSpread(_objectSpread({}, provided), {}, {
              color: "#FFF",
              backgroundColor: "#101112",
              fontSize: "14px"
            }),
            option: provided => _objectSpread(_objectSpread({}, provided), {}, {
              padding: "4px 16px",
              color: "#FFF",
              backgroundColor: "#101112",
              fontSize: "14px"
            }),
            singleValue: provided => _objectSpread(_objectSpread({}, provided), {}, {
              color: "#FFF",
              marginLeft: "0",
              marginRight: "0",
              fontSize: "14px",
              backgroundColor: "#101112"
            })
          }
        })
      })
    }), /*#__PURE__*/_jsx(Button, {
      fontFixed: true,
      large: true,
      fillWhiteColor: true,
      onClick: handleReportSend,
      children: "\u901A\u5831\u3059\u308B"
    }, "reportSendButton"), /*#__PURE__*/_jsx(Button, {
      fontFixed: true,
      large: true,
      borderLight: true,
      onClick: props.modalCloseHandle,
      children: "\u9589\u3058\u308B"
    })]
  });
};
export default ChatMessageReportStepReport;